
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import PropTypes from "prop-types"; // Prop validation

const AddDecayCustomerPayment = ({ props, handleClose, show }) => {
  const paymentmethod = [
    { id: "Virement", text: "Virement" },
    { id: "Espece", text: "Espece" },
    { id: "Cheque", text: "Cheque" },
  ];
 let season_id = localStorage.getItem("season_id");

  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const defaultDate = formatDate(new Date());

  const [formData, setFormData] = useState({
    customer: props,
    date: defaultDate,
    season_id:season_id,
    amount: "",
    operation: "",
    payment_method: "",
    note: "",
  });

  console.log("Customer ID:", props);

  useEffect(() => {
    // If there's an effect needed in the future, add it here
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    axios
      .post("/decay-sales/add-customer-payment", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        $("#form-submit").text("Submit");
        setBackendErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors["error"];
          return newErrors;
        });

        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = "/decay-sales-customer/" + props;
          }, 500);
        } else {
          setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const customHandleInput = (event) => {
    const input_name = event.target.name;
    setBackendErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[input_name];
      return newErrors;
    });
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header>
        <h4 className="modal-title">Add Customer Payment</h4>
        <button type="button" className="close" data-bs-dismiss="modal" onClick={handleClose} aria-hidden="true">
          &times;
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          {backendSuccess && <div className="form-success mt-1">{backendSuccess}</div>}

          <div className="form-group">
            <label>Date</label>
            <input
              className="form-control form-white"
              placeholder="Select Date"
              type="date"
              name="date"
              value={formData.date}
              onChange={(e) => {
                handleChange(e);
                customHandleInput(e);
              }}
            />
            <small>{backendErrors.date && <span className="form-error mt-1">{backendErrors.date}</span>}</small>
          </div>

          <div className="form-group">
            <label>Amount </label>
            <input
              className="form-control form-white"
              placeholder="Enter amount"
              type="text"
              name="amount"
              value={formData.amount}
              onKeyPress={(event) => {
                if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                handleChange(e);
                customHandleInput(e);
              }}
            />
            <small>{backendErrors.amount && <span className="form-error mt-1">{backendErrors.amount}</span>}</small>
          </div>

          {paymentmethod.length > 0 && (
            <div className="form-group mb-0">
              <label>Select Payment Type </label>
              <select
                className="form-control form-white"
                name="payment_method"
                value={formData.payment_method}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
              >
                <option value="">Select</option>
                {paymentmethod.map((shipp) => (
                  <option key={shipp.id} value={shipp.id}>
                    {shipp.text}
                  </option>
                ))}
              </select>
              <small>
                {backendErrors.payment_method && <span className="form-error mt-1">{backendErrors.payment_method}</span>}
              </small>
            </div>
          )}

          <div className="form-group">
            <label>Note: </label>
            <textarea
              className="form-control form-white"
              placeholder="Enter Note"
              name="note"
              value={formData.note}
              onChange={(e) => {
                handleChange(e);
                customHandleInput(e);
              }}
            ></textarea>
            <small>{backendErrors.note && <span className="form-error mt-1">{backendErrors.note}</span>}</small>
          </div>

          <div className="submit-section">
            <button type="submit" className="btn btn-primary save-category submit-btn" data-bs-dismiss="modal">
              SUBMIT
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

// ✅ Updated PropTypes Validation
AddDecayCustomerPayment.propTypes = {
  props: PropTypes.any.isRequired, // If props is an object, use PropTypes.object

  // customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // Corrected from 'props'
  show: PropTypes.bool.isRequired, // Should be a boolean
  handleClose: PropTypes.func.isRequired, // Required function prop
};

export default AddDecayCustomerPayment;
